// @flow
export const UPDATE_USER_INFORMATIONS_FETCH = 'UPDATE_USER_INFORMATIONS_FETCH'
export const UPDATE_USER_INFORMATIONS_SUCCESS = 'UPDATE_USER_INFORMATIONS_SUCCESS'
export const UPDATE_USER_INFORMATIONS_FAIL = 'UPDATE_USER_INFORMATIONS_FAIL'
